var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path, _path2, _g9, _g10, _g11, _path3, _path4, _g12, _g13, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDigestTooltipIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 158,
    viewBox: "0 0 209 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_2750_97145)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    width: 59,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 12,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1A8287"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2750_97145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3336 14.666L18.3648 18.2286C18.2485 18.3682 18.1904 18.4379 18.1895 18.4968C18.1887 18.5481 18.2115 18.5968 18.2514 18.629C18.2972 18.666 18.388 18.666 18.5696 18.666H21.0003L20.6669 21.3327L23.6358 17.7701C23.7521 17.6305 23.8102 17.5608 23.8111 17.5019C23.8119 17.4506 23.789 17.4019 23.7492 17.3697C23.7034 17.3327 23.6126 17.3327 23.4309 17.3327H21.0003L21.3336 14.666Z",
    stroke: "#F1FCFA",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.7191 21.5V14.9545H35.8228V15.8047H32.7067V17.799H35.6087V18.646H32.7067V20.6499H35.8612V21.5H31.7191ZM41.2648 16.5909L39.4846 21.5H38.4619L36.6785 16.5909H37.7045L38.9477 20.3686H38.9988L40.2389 16.5909H41.2648ZM44.1117 21.5991C43.628 21.5991 43.2115 21.4957 42.862 21.2891C42.5147 21.0803 42.2463 20.7873 42.0566 20.4102C41.8691 20.0309 41.7754 19.5866 41.7754 19.0774C41.7754 18.5746 41.8691 18.1314 42.0566 17.7479C42.2463 17.3643 42.5105 17.065 42.8493 16.8498C43.1902 16.6346 43.5886 16.527 44.0446 16.527C44.3216 16.527 44.59 16.5728 44.85 16.6644C45.1099 16.756 45.3432 16.8999 45.5499 17.0959C45.7566 17.2919 45.9196 17.5465 46.0389 17.8597C46.1582 18.1708 46.2179 18.549 46.2179 18.9943V19.3331H42.3155V18.6172H45.2814C45.2814 18.3658 45.2303 18.1431 45.128 17.9492C45.0257 17.7532 44.8819 17.5987 44.6966 17.4858C44.5133 17.3729 44.2981 17.3164 44.051 17.3164C43.7825 17.3164 43.5481 17.3825 43.3478 17.5146C43.1497 17.6445 42.9963 17.815 42.8876 18.0259C42.7811 18.2347 42.7278 18.4616 42.7278 18.7067V19.266C42.7278 19.5941 42.7853 19.8732 42.9004 20.1033C43.0176 20.3335 43.1806 20.5092 43.3894 20.6307C43.5982 20.75 43.8422 20.8097 44.1213 20.8097C44.3024 20.8097 44.4675 20.7841 44.6167 20.733C44.7658 20.6797 44.8947 20.6009 45.0034 20.4964C45.112 20.392 45.1951 20.2631 45.2527 20.1097L46.1571 20.2727C46.0847 20.5391 45.9547 20.7724 45.7672 20.9727C45.5819 21.1708 45.3485 21.3253 45.0673 21.4361C44.7882 21.5447 44.4696 21.5991 44.1117 21.5991ZM48.2338 18.5852V21.5H47.2781V16.5909H48.1954V17.3899H48.2561C48.3691 17.13 48.5459 16.9212 48.7867 16.7635C49.0296 16.6058 49.3353 16.527 49.7039 16.527C50.0384 16.527 50.3314 16.5973 50.5828 16.7379C50.8343 16.8764 51.0292 17.0831 51.1677 17.358C51.3062 17.6328 51.3754 17.9727 51.3754 18.3775V21.5H50.4198V18.4925C50.4198 18.1367 50.3271 17.8587 50.1418 17.6584C49.9564 17.456 49.7018 17.3548 49.3779 17.3548C49.1563 17.3548 48.9593 17.4027 48.7867 17.4986C48.6162 17.5945 48.4809 17.7351 48.3808 17.9205C48.2828 18.1037 48.2338 18.3253 48.2338 18.5852ZM54.9486 16.5909V17.358H52.2671V16.5909H54.9486ZM52.9862 15.4148H53.9419V20.0586C53.9419 20.244 53.9695 20.3835 54.0249 20.4773C54.0803 20.5689 54.1517 20.6317 54.2391 20.6658C54.3286 20.6978 54.4255 20.7138 54.5299 20.7138C54.6066 20.7138 54.6737 20.7085 54.7313 20.6978C54.7888 20.6871 54.8335 20.6786 54.8655 20.6722L55.0381 21.4616C54.9827 21.483 54.9039 21.5043 54.8016 21.5256C54.6993 21.549 54.5715 21.5618 54.4181 21.5639C54.1666 21.5682 53.9323 21.5234 53.7149 21.4297C53.4976 21.3359 53.3218 21.1911 53.1876 20.995C53.0534 20.799 52.9862 20.5529 52.9862 20.2567V15.4148ZM60.858 14.9545V21.5H59.8673V15.9453H59.8289L58.2629 16.968V16.022L59.896 14.9545H60.858Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ddd_2750_97145)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 6,
    width: 61,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 12,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1A8287"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2750_97145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.334 14.666L148.365 18.2286C148.248 18.3682 148.19 18.4379 148.189 18.4968C148.189 18.5481 148.212 18.5968 148.251 18.629C148.297 18.666 148.388 18.666 148.57 18.666H151L150.667 21.3327L153.636 17.7701C153.752 17.6305 153.81 17.5608 153.811 17.5019C153.812 17.4506 153.789 17.4019 153.749 17.3697C153.703 17.3327 153.613 17.3327 153.431 17.3327H151L151.334 14.666Z",
    stroke: "#F1FCFA",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M161.719 21.5V14.9545H165.823V15.8047H162.707V17.799H165.609V18.646H162.707V20.6499H165.861V21.5H161.719ZM171.265 16.5909L169.485 21.5H168.462L166.679 16.5909H167.704L168.948 20.3686H168.999L170.239 16.5909H171.265ZM174.112 21.5991C173.628 21.5991 173.211 21.4957 172.862 21.2891C172.515 21.0803 172.246 20.7873 172.057 20.4102C171.869 20.0309 171.775 19.5866 171.775 19.0774C171.775 18.5746 171.869 18.1314 172.057 17.7479C172.246 17.3643 172.51 17.065 172.849 16.8498C173.19 16.6346 173.589 16.527 174.045 16.527C174.322 16.527 174.59 16.5728 174.85 16.6644C175.11 16.756 175.343 16.8999 175.55 17.0959C175.757 17.2919 175.92 17.5465 176.039 17.8597C176.158 18.1708 176.218 18.549 176.218 18.9943V19.3331H172.316V18.6172H175.281C175.281 18.3658 175.23 18.1431 175.128 17.9492C175.026 17.7532 174.882 17.5987 174.697 17.4858C174.513 17.3729 174.298 17.3164 174.051 17.3164C173.782 17.3164 173.548 17.3825 173.348 17.5146C173.15 17.6445 172.996 17.815 172.888 18.0259C172.781 18.2347 172.728 18.4616 172.728 18.7067V19.266C172.728 19.5941 172.785 19.8732 172.9 20.1033C173.018 20.3335 173.181 20.5092 173.389 20.6307C173.598 20.75 173.842 20.8097 174.121 20.8097C174.302 20.8097 174.468 20.7841 174.617 20.733C174.766 20.6797 174.895 20.6009 175.003 20.4964C175.112 20.392 175.195 20.2631 175.253 20.1097L176.157 20.2727C176.085 20.5391 175.955 20.7724 175.767 20.9727C175.582 21.1708 175.349 21.3253 175.067 21.4361C174.788 21.5447 174.47 21.5991 174.112 21.5991ZM178.234 18.5852V21.5H177.278V16.5909H178.195V17.3899H178.256C178.369 17.13 178.546 16.9212 178.787 16.7635C179.03 16.6058 179.335 16.527 179.704 16.527C180.038 16.527 180.331 16.5973 180.583 16.7379C180.834 16.8764 181.029 17.0831 181.168 17.358C181.306 17.6328 181.375 17.9727 181.375 18.3775V21.5H180.42V18.4925C180.42 18.1367 180.327 17.8587 180.142 17.6584C179.956 17.456 179.702 17.3548 179.378 17.3548C179.156 17.3548 178.959 17.4027 178.787 17.4986C178.616 17.5945 178.481 17.7351 178.381 17.9205C178.283 18.1037 178.234 18.3253 178.234 18.5852ZM184.949 16.5909V17.358H182.267V16.5909H184.949ZM182.986 15.4148H183.942V20.0586C183.942 20.244 183.97 20.3835 184.025 20.4773C184.08 20.5689 184.152 20.6317 184.239 20.6658C184.329 20.6978 184.426 20.7138 184.53 20.7138C184.607 20.7138 184.674 20.7085 184.731 20.6978C184.789 20.6871 184.834 20.6786 184.866 20.6722L185.038 21.4616C184.983 21.483 184.904 21.5043 184.802 21.5256C184.699 21.549 184.571 21.5618 184.418 21.5639C184.167 21.5682 183.932 21.5234 183.715 21.4297C183.498 21.3359 183.322 21.1911 183.188 20.995C183.053 20.799 182.986 20.5529 182.986 20.2567V15.4148ZM190.653 21.5895C190.215 21.5895 189.823 21.5138 189.477 21.3626C189.134 21.2113 188.863 21.0014 188.662 20.733C188.464 20.4624 188.358 20.1491 188.343 19.7933H189.346C189.359 19.9872 189.424 20.1555 189.541 20.2983C189.661 20.4389 189.816 20.5476 190.008 20.6243C190.2 20.701 190.413 20.7393 190.647 20.7393C190.905 20.7393 191.133 20.6946 191.331 20.6051C191.531 20.5156 191.688 20.391 191.801 20.2312C191.914 20.0692 191.97 19.8828 191.97 19.6719C191.97 19.4524 191.914 19.2596 191.801 19.0934C191.69 18.9251 191.527 18.793 191.312 18.6971C191.099 18.6012 190.841 18.5533 190.538 18.5533H189.986V17.7479H190.538C190.781 17.7479 190.994 17.7042 191.178 17.6168C191.363 17.5295 191.508 17.408 191.612 17.2525C191.717 17.0948 191.769 16.9105 191.769 16.6996C191.769 16.4972 191.723 16.3214 191.631 16.1722C191.542 16.021 191.414 15.9027 191.248 15.8175C191.084 15.7322 190.89 15.6896 190.666 15.6896C190.453 15.6896 190.254 15.729 190.069 15.8079C189.885 15.8846 189.736 15.9954 189.621 16.1403C189.506 16.283 189.444 16.4545 189.436 16.6548H188.48C188.491 16.3011 188.595 15.9901 188.793 15.7216C188.994 15.4531 189.258 15.2433 189.586 15.092C189.914 14.9407 190.278 14.8651 190.679 14.8651C191.099 14.8651 191.461 14.9471 191.766 15.1112C192.073 15.2731 192.309 15.4893 192.475 15.7599C192.644 16.0305 192.727 16.3267 192.725 16.6484C192.727 17.0149 192.624 17.326 192.418 17.5817C192.213 17.8374 191.94 18.0089 191.6 18.0962V18.1474C192.034 18.2134 192.371 18.386 192.609 18.6651C192.85 18.9442 192.97 19.2905 192.967 19.7038C192.97 20.0639 192.869 20.3867 192.667 20.6722C192.467 20.9577 192.193 21.1825 191.846 21.3466C191.498 21.5085 191.101 21.5895 190.653 21.5895Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ddddddi_2750_97145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.8803 80.6C86.8803 77.2397 86.8803 75.5595 87.5342 74.2761C88.1095 73.1471 89.0273 72.2292 90.1563 71.654C91.4398 71 93.1199 71 96.4803 71H112.28C115.641 71 117.321 71 118.604 71.654C119.733 72.2292 120.651 73.1471 121.226 74.2761C121.88 75.5595 121.88 77.2397 121.88 80.6V101.4C121.88 104.76 121.88 106.44 121.226 107.724C120.651 108.853 119.733 109.771 118.604 110.346C117.321 111 115.641 111 112.28 111H96.4803C93.1199 111 91.4398 111 90.1563 110.346C89.0273 109.771 88.1095 108.853 87.5342 107.724C86.8803 106.44 86.8803 104.76 86.8803 101.4V80.6Z",
    fill: "url(#paint0_linear_2750_97145)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2750_97145)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.693,
    cy: 78.1273,
    rx: 19.9119,
    ry: 5.38543,
    fill: "url(#paint1_linear_2750_97145)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ddddddi_2750_97145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.8803 83.6C83.8803 80.2397 83.8803 78.5595 84.5342 77.2761C85.1095 76.1471 86.0273 75.2292 87.1563 74.654C88.4398 74 90.1199 74 93.4803 74H115.28C118.641 74 120.321 74 121.604 74.654C122.733 75.2292 123.651 76.1471 124.226 77.2761C124.88 78.5595 124.88 80.2397 124.88 83.6V110.4C124.88 113.76 124.88 115.44 124.226 116.724C123.651 117.853 122.733 118.771 121.604 119.346C120.321 120 118.641 120 115.28 120H93.4803C90.1199 120 88.4398 120 87.1563 119.346C86.0273 118.771 85.1095 117.853 84.5342 116.724C83.8803 115.44 83.8803 113.76 83.8803 110.4V83.6Z",
    fill: "url(#paint2_linear_2750_97145)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_2750_97145)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 105,
    cy: 79.5,
    rx: 20,
    ry: 3.5,
    fill: "url(#paint3_linear_2750_97145)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ddddddi_2750_97145)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 78,
    width: 45,
    height: 46,
    rx: 6,
    fill: "url(#paint4_linear_2750_97145)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87,
    y: 83,
    width: 35,
    height: 36,
    rx: 3.62808,
    fill: "url(#paint5_linear_2750_97145)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_2750_97145)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 88,
    width: 6,
    height: 6,
    rx: 1,
    fill: "url(#paint6_linear_2750_97145)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_2750_97145)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 90,
    width: 17,
    height: 2,
    rx: 1,
    fill: "url(#paint7_linear_2750_97145)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_2750_97145)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 98,
    width: 6,
    height: 6,
    rx: 1,
    fill: "url(#paint8_linear_2750_97145)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i_2750_97145)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 100,
    width: 17,
    height: 2,
    rx: 1,
    fill: "url(#paint9_linear_2750_97145)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_2750_97145)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 108,
    width: 6,
    height: 6,
    rx: 1,
    fill: "url(#paint10_linear_2750_97145)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_i_2750_97145)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 110,
    width: 17,
    height: 2,
    rx: 1,
    fill: "url(#paint11_linear_2750_97145)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d_2750_97145)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 74,
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "#F61A69",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.206 82V78.042H127.144L125.934 78.8828V77.9531L127.209 77.0679H128.238V82H127.206Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104 63V58.2902C104 52.7674 99.5228 48.2902 94 48.2902H42C36.4772 48.2902 32 43.8131 32 38.2902V30",
    stroke: "#42CFEF",
    strokeWidth: 0.75,
    strokeDasharray: "3 1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104 63V58.2902C104 52.7674 108.477 48.2902 114 48.2902H166C171.523 48.2902 176 43.8131 176 38.2902V30",
    stroke: "#42CFEF",
    strokeWidth: 0.75,
    strokeDasharray: "3 1"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_f_2750_97145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104 63V58.2902C104 52.7674 108.477 48.2902 114 48.2902H166C171.523 48.2902 176 43.8131 176 38.2902V30",
    stroke: "#7DA0FF",
    strokeWidth: 0.75,
    strokeDasharray: "3 1"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_f_2750_97145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104 63V58.2902C104 52.7674 99.5228 48.2902 94 48.2902H42C36.4772 48.2902 32 43.8131 32 38.2902V30",
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeDasharray: "3 1"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_f_2750_97145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.735 70.2652C103.881 70.4116 104.119 70.4116 104.265 70.2652L106.652 67.8787C106.798 67.7322 106.798 67.4948 106.652 67.3483C106.505 67.2019 106.268 67.2019 106.121 67.3483L104 69.4697L101.879 67.3484C101.732 67.2019 101.495 67.2019 101.348 67.3484C101.202 67.4948 101.202 67.7322 101.348 67.8787L103.735 70.2652ZM103.625 63L103.625 64.3125L104.375 64.3125L104.375 63L103.625 63ZM103.625 65.1875L103.625 67.8125L104.375 67.8125L104.375 65.1875L103.625 65.1875ZM103.625 68.6875L103.625 70L104.375 70L104.375 68.6875L103.625 68.6875Z",
    fill: "#7DB9FF"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M103.735 70.2652C103.881 70.4116 104.119 70.4116 104.265 70.2652L106.652 67.8787C106.798 67.7322 106.798 67.4948 106.652 67.3483C106.505 67.2019 106.268 67.2019 106.121 67.3483L104 69.4697L101.879 67.3484C101.732 67.2019 101.495 67.2019 101.348 67.3484C101.202 67.4948 101.202 67.7322 101.348 67.8787L103.735 70.2652ZM103.625 63L103.625 64.3125L104.375 64.3125L104.375 63L103.625 63ZM103.625 65.1875L103.625 67.8125L104.375 67.8125L104.375 65.1875L103.625 65.1875ZM103.625 68.6875L103.625 70L104.375 70L104.375 68.6875L103.625 68.6875Z",
    fill: "#42CFEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104 42L104 54",
    stroke: "#42CFEF",
    strokeWidth: 0.75,
    strokeDasharray: "4 1"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_f_2750_97145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104 43L104 54",
    stroke: "#7DB9FF",
    strokeWidth: 0.75,
    strokeDasharray: "3 1"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_ddd_2750_97145)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73,
    y: 18,
    width: 61,
    height: 24,
    rx: 4,
    fill: "white",
    fillOpacity: 0.12,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 24,
    width: 12,
    height: 12,
    rx: 2,
    fill: "#1A8287"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2750_97145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.3336 26.666L82.3648 30.2286C82.2485 30.3682 82.1904 30.4379 82.1895 30.4968C82.1887 30.5481 82.2115 30.5968 82.2514 30.629C82.2972 30.666 82.388 30.666 82.5696 30.666H85.0003L84.6669 33.3327L87.6358 29.7701C87.7521 29.6305 87.8102 29.5608 87.8111 29.5019C87.8119 29.4506 87.789 29.4019 87.7492 29.3697C87.7034 29.3327 87.6126 29.3327 87.4309 29.3327H85.0003L85.3336 26.666Z",
    stroke: "#F1FCFA",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.7191 33.5V26.9545H99.8228V27.8047H96.7067V29.799H99.6087V30.646H96.7067V32.6499H99.8612V33.5H95.7191ZM105.265 28.5909L103.485 33.5H102.462L100.679 28.5909H101.704L102.948 32.3686H102.999L104.239 28.5909H105.265ZM108.112 33.5991C107.628 33.5991 107.211 33.4957 106.862 33.2891C106.515 33.0803 106.246 32.7873 106.057 32.4102C105.869 32.0309 105.775 31.5866 105.775 31.0774C105.775 30.5746 105.869 30.1314 106.057 29.7479C106.246 29.3643 106.51 29.065 106.849 28.8498C107.19 28.6346 107.589 28.527 108.045 28.527C108.322 28.527 108.59 28.5728 108.85 28.6644C109.11 28.756 109.343 28.8999 109.55 29.0959C109.757 29.2919 109.92 29.5465 110.039 29.8597C110.158 30.1708 110.218 30.549 110.218 30.9943V31.3331H106.316V30.6172H109.281C109.281 30.3658 109.23 30.1431 109.128 29.9492C109.026 29.7532 108.882 29.5987 108.697 29.4858C108.513 29.3729 108.298 29.3164 108.051 29.3164C107.782 29.3164 107.548 29.3825 107.348 29.5146C107.15 29.6445 106.996 29.815 106.888 30.0259C106.781 30.2347 106.728 30.4616 106.728 30.7067V31.266C106.728 31.5941 106.785 31.8732 106.9 32.1033C107.018 32.3335 107.181 32.5092 107.389 32.6307C107.598 32.75 107.842 32.8097 108.121 32.8097C108.302 32.8097 108.468 32.7841 108.617 32.733C108.766 32.6797 108.895 32.6009 109.003 32.4964C109.112 32.392 109.195 32.2631 109.253 32.1097L110.157 32.2727C110.085 32.5391 109.955 32.7724 109.767 32.9727C109.582 33.1708 109.349 33.3253 109.067 33.4361C108.788 33.5447 108.47 33.5991 108.112 33.5991ZM112.234 30.5852V33.5H111.278V28.5909H112.195V29.3899H112.256C112.369 29.13 112.546 28.9212 112.787 28.7635C113.03 28.6058 113.335 28.527 113.704 28.527C114.038 28.527 114.331 28.5973 114.583 28.7379C114.834 28.8764 115.029 29.0831 115.168 29.358C115.306 29.6328 115.375 29.9727 115.375 30.3775V33.5H114.42V30.4925C114.42 30.1367 114.327 29.8587 114.142 29.6584C113.956 29.456 113.702 29.3548 113.378 29.3548C113.156 29.3548 112.959 29.4027 112.787 29.4986C112.616 29.5945 112.481 29.7351 112.381 29.9205C112.283 30.1037 112.234 30.3253 112.234 30.5852ZM118.949 28.5909V29.358H116.267V28.5909H118.949ZM116.986 27.4148H117.942V32.0586C117.942 32.244 117.97 32.3835 118.025 32.4773C118.08 32.5689 118.152 32.6317 118.239 32.6658C118.329 32.6978 118.426 32.7138 118.53 32.7138C118.607 32.7138 118.674 32.7085 118.731 32.6978C118.789 32.6871 118.834 32.6786 118.866 32.6722L119.038 33.4616C118.983 33.483 118.904 33.5043 118.802 33.5256C118.699 33.549 118.571 33.5618 118.418 33.5639C118.167 33.5682 117.932 33.5234 117.715 33.4297C117.498 33.3359 117.322 33.1911 117.188 32.995C117.053 32.799 116.986 32.5529 116.986 32.2567V27.4148ZM122.375 33.5V32.7841L124.59 30.4893C124.826 30.2401 125.021 30.0217 125.174 29.8342C125.33 29.6445 125.446 29.4645 125.523 29.294C125.6 29.1236 125.638 28.9425 125.638 28.7507C125.638 28.5334 125.587 28.3459 125.484 28.1882C125.382 28.0284 125.243 27.9059 125.066 27.8207C124.889 27.7333 124.69 27.6896 124.468 27.6896C124.234 27.6896 124.029 27.7376 123.854 27.8335C123.68 27.9293 123.546 28.0646 123.452 28.2393C123.358 28.4141 123.311 28.6186 123.311 28.853H122.368C122.368 28.4545 122.46 28.1062 122.643 27.8079C122.826 27.5096 123.078 27.2784 123.397 27.1143C123.717 26.9482 124.08 26.8651 124.487 26.8651C124.899 26.8651 125.261 26.9471 125.574 27.1112C125.889 27.2731 126.135 27.4947 126.312 27.7759C126.489 28.055 126.578 28.3704 126.578 28.7219C126.578 28.9648 126.532 29.2024 126.44 29.4347C126.351 29.6669 126.194 29.9258 125.97 30.2113C125.747 30.4947 125.435 30.8388 125.037 31.2436L123.736 32.6051V32.6531H126.683V33.5H122.375Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_2750_97145",
    x: 0,
    y: 0,
    width: 77,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2750_97145",
    result: "effect2_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2750_97145",
    result: "effect3_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_2750_97145",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_2750_97145",
    x: 130,
    y: 0,
    width: 79,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2750_97145",
    result: "effect2_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2750_97145",
    result: "effect3_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_2750_97145",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddddddi_2750_97145",
    x: 70.724,
    y: 71,
    width: 67.3126,
    height: 73.3046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.474539
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.223543
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.230588 0 0 0 0 0.384314 0 0 0 0.0674749 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.14038
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.537205
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.231373 0 0 0 0 0.384314 0 0 0 0.0969343 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2750_97145",
    result: "effect2_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.14724
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.01151
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.231373 0 0 0 0 0.384314 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2750_97145",
    result: "effect3_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.83031
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.80436
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.231373 0 0 0 0 0.384314 0 0 0 0.143066 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2750_97145",
    result: "effect4_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.16417
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.37486
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.231373 0 0 0 0 0.384314 0 0 0 0.172525 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_2750_97145",
    result: "effect5_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.1483
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.07815
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.231373 0 0 0 0 0.384314 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_2750_97145",
    result: "effect6_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_2750_97145",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.283444,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect7_innerShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.141722
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect7_innerShadow_2750_97145"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2750_97145",
    x: 81.7809,
    y: 69.7418,
    width: 45.8238,
    height: 16.7709,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_2750_97145"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ddddddi_2750_97145",
    x: 67.724,
    y: 74,
    width: 73.3126,
    height: 79.3046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.474539
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.223543
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.230588 0 0 0 0 0.384314 0 0 0 0.0674749 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.14038
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.537205
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.231373 0 0 0 0 0.384314 0 0 0 0.0969343 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2750_97145",
    result: "effect2_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.14724
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.01151
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.231373 0 0 0 0 0.384314 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2750_97145",
    result: "effect3_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.83031
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.80436
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.231373 0 0 0 0 0.384314 0 0 0 0.143066 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2750_97145",
    result: "effect4_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.16417
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.37486
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.231373 0 0 0 0 0.384314 0 0 0 0.172525 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_2750_97145",
    result: "effect5_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.1483
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.07815
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.231373 0 0 0 0 0.384314 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_2750_97145",
    result: "effect6_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_2750_97145",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.283444,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect7_innerShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.141722
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect7_innerShadow_2750_97145"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2750_97145",
    x: 82,
    y: 73,
    width: 46,
    height: 13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_2750_97145"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ddddddi_2750_97145",
    x: 65.8437,
    y: 78,
    width: 77.3126,
    height: 79.3046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.474539
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.223543
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.230588 0 0 0 0 0.384314 0 0 0 0.0674749 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.14038
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.537205
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.231373 0 0 0 0 0.384314 0 0 0 0.0969343 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2750_97145",
    result: "effect2_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.14724
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.01151
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.231373 0 0 0 0 0.384314 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2750_97145",
    result: "effect3_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.83031
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.80436
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.231373 0 0 0 0 0.384314 0 0 0 0.143066 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect3_dropShadow_2750_97145",
    result: "effect4_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 7.16417
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.37486
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.231373 0 0 0 0 0.384314 0 0 0 0.172525 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect4_dropShadow_2750_97145",
    result: "effect5_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 17.1483
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.07815
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.231373 0 0 0 0 0.384314 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect5_dropShadow_2750_97145",
    result: "effect6_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect6_dropShadow_2750_97145",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.283444,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect7_innerShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.141722
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect7_innerShadow_2750_97145"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_2750_97145",
    x: 92,
    y: 88,
    width: 6,
    height: 7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2750_97145"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_2750_97145",
    x: 101,
    y: 90,
    width: 17,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2750_97145"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_2750_97145",
    x: 92,
    y: 98,
    width: 6,
    height: 7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2750_97145"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_2750_97145",
    x: 101,
    y: 100,
    width: 17,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2750_97145"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_2750_97145",
    x: 92,
    y: 108,
    width: 6,
    height: 7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2750_97145"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_i_2750_97145",
    x: 101,
    y: 110,
    width: 17,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2750_97145"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d_2750_97145",
    x: 119.25,
    y: 71.25,
    width: 16.5,
    height: 16.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.969808 0 0 0 0 0.288496 0 0 0 0 0.533149 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2750_97145",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_f_2750_97145",
    x: 94.625,
    y: 21,
    width: 90.75,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "effect1_foregroundBlur_2750_97145"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_f_2750_97145",
    x: 22.625,
    y: 21,
    width: 90.75,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "effect1_foregroundBlur_2750_97145"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_f_2750_97145",
    x: 92.2385,
    y: 54,
    width: 23.523,
    height: 25.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "effect1_foregroundBlur_2750_97145"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_f_2750_97145",
    x: 94.625,
    y: 34,
    width: 18.75,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5,
    result: "effect1_foregroundBlur_2750_97145"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_ddd_2750_97145",
    x: 64,
    y: 12,
    width: 79,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0588235 0 0 0 0 0.0901961 0 0 0 0 0.164706 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2750_97145",
    result: "effect2_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.160784 0 0 0 0 0.231373 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2750_97145",
    result: "effect3_dropShadow_2750_97145"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_2750_97145",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2750_97145",
    x1: 104.38,
    y1: 71,
    x2: 104.38,
    y2: 113.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64452,
    stopColor: "#ECF7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952359,
    stopColor: "#9FBECD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2750_97145",
    x1: 84.7809,
    y1: 78.1273,
    x2: 124.605,
    y2: 78.1273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2874CC",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#094CD2",
    stopOpacity: 0.36
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2750_97145",
    x1: 104.38,
    y1: 74,
    x2: 104.38,
    y2: 122.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64452,
    stopColor: "#ECF7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952359,
    stopColor: "#9FBECD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2750_97145",
    x1: 85,
    y1: 79.5,
    x2: 125,
    y2: 79.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E93CF",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3164CB",
    stopOpacity: 0.36
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2750_97145",
    x1: 104.5,
    y1: 78,
    x2: 104.5,
    y2: 126.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64452,
    stopColor: "#ECF7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952359,
    stopColor: "#9FBECD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2750_97145",
    x1: 120.5,
    y1: 83,
    x2: 87.683,
    y2: 118.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007AD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2750_97145",
    x1: 95,
    y1: 88.2093,
    x2: 95,
    y2: 93.7907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2750_97145",
    x1: 109.5,
    y1: 90.0698,
    x2: 109.5,
    y2: 91.9302,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2750_97145",
    x1: 95,
    y1: 98.2093,
    x2: 95,
    y2: 103.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2750_97145",
    x1: 109.5,
    y1: 100.07,
    x2: 109.5,
    y2: 101.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2750_97145",
    x1: 95,
    y1: 108.209,
    x2: 95,
    y2: 113.791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2750_97145",
    x1: 109.5,
    y1: 110.07,
    x2: 109.5,
    y2: 111.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDE0F2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2750_97145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(17 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2750_97145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(147 14)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2750_97145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    fill: "white",
    transform: "translate(81 26)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigestTooltipIcon);
export default __webpack_public_path__ + "static/media/digestTooltipIcon.c2cc5f43267a8464b21e3d7261f45d2a.svg";
export { ForwardRef as ReactComponent };